import { useEffect, useState } from 'react';
import { fetchPlanTiersForUsers } from '../services/pluginPlanService';

export function useUserPlanTiers(users, productId, freeSlug, proSlug) {
	const [planByUserId, setPlanByUserId] = useState({});

	useEffect(() => {
		if (!users?.length || !productId || !freeSlug) {
			setPlanByUserId({});
			return undefined;
		}

		let cancelled = false;

		fetchPlanTiersForUsers(users, productId, freeSlug, proSlug).then((map) => {
			if (!cancelled) {
				setPlanByUserId(map);
			}
		});

		return () => {
			cancelled = true;
		};
	}, [users, productId, freeSlug, proSlug]);

	return planByUserId;
}
